/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorMessage,
  RetriedPaymentDto,
  RetryPaymentDto,
} from '../models';
import {
    ErrorMessageFromJSON,
    ErrorMessageToJSON,
    RetriedPaymentDtoFromJSON,
    RetriedPaymentDtoToJSON,
    RetryPaymentDtoFromJSON,
    RetryPaymentDtoToJSON,
} from '../models';

export interface RetryPaymentV3Request {
    locationId: string;
    paymentReference: string;
    retryPaymentDto: RetryPaymentDto;
}

/**
 * 
 */
export class RetryPaymentControllerApi extends runtime.BaseAPI {

    /**
     */
    async retryPaymentV3Raw(requestParameters: RetryPaymentV3Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RetriedPaymentDto>> {
        if (requestParameters.locationId === null || requestParameters.locationId === undefined) {
            throw new runtime.RequiredError('locationId','Required parameter requestParameters.locationId was null or undefined when calling retryPaymentV3.');
        }

        if (requestParameters.paymentReference === null || requestParameters.paymentReference === undefined) {
            throw new runtime.RequiredError('paymentReference','Required parameter requestParameters.paymentReference was null or undefined when calling retryPaymentV3.');
        }

        if (requestParameters.retryPaymentDto === null || requestParameters.retryPaymentDto === undefined) {
            throw new runtime.RequiredError('retryPaymentDto','Required parameter requestParameters.retryPaymentDto was null or undefined when calling retryPaymentV3.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v3/locations/{locationId}/payments/{payment-reference}/retry`.replace(`{${"locationId"}}`, encodeURIComponent(String(requestParameters.locationId))).replace(`{${"payment-reference"}}`, encodeURIComponent(String(requestParameters.paymentReference))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RetryPaymentDtoToJSON(requestParameters.retryPaymentDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RetriedPaymentDtoFromJSON(jsonValue));
    }

    /**
     */
    async retryPaymentV3(requestParameters: RetryPaymentV3Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RetriedPaymentDto> {
        const response = await this.retryPaymentV3Raw(requestParameters, initOverrides);
        return await response.value();
    }

}
